// Export the Component Definition for use in Contentful Studio
export {SkinnyBannerContentfulComponentDefinition} from './SkinnyBannerContentfulDefinition';
export {default} from './SkinnyBanner';
